import React, { useState,useEffect } from "react";
import {
  IconButton,
  Menu,
  MenuItem,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { fetchBlogs } from "../Api/blogFetch";
// import { set } from "react-hook-form";
function UserProfileMenu({
  userProfileImage,
  onLogout,
  username,
  email,
}) {
  const [anchorEl, setAnchorEl] = useState(null);
  const [isLogoutDialogOpen, setIsLogoutDialogOpen] = useState(false);
  const [isProfileDialogOpen, setIsProfileDialogOpen] = useState(false);
  // const [isDashboardDialogOpen, setIsDashboardDialogOpen] = useState(false);
  const [userPosts, setUserPosts] = useState([]);
 const [totalPosts, setTotalPosts] = useState(0); 
  

  useEffect(() => {
    const fetchData = async () => {
      // Fetch the blog posts
      const result = await fetchBlogs();
      // console.log("All Posts:", result.data);

      // Get the user_id from localStorage
      const currentUserId = localStorage.getItem("userId");
        // console.log("Current User ID:", currentUserId);
      // Filter posts by user_id
      if (currentUserId) {
        const filteredPosts = result.data.filter(post => post.user_id === currentUserId);
        setTotalPosts(filteredPosts.length);
        console.log("Filtered User Posts:", filteredPosts);
        setUserPosts(filteredPosts); // Set the filtered posts to state
      }
    };
    fetchData();
  }, []);


  const navigate = useNavigate();

  const handleAdmin = () => {
    navigate("/admin");
  };

  const handleMenu = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleLogoutClick = () => {
    handleClose();
    setIsLogoutDialogOpen(true);
  };

  const handleLogoutConfirm = () => {
    setIsLogoutDialogOpen(false);
    onLogout();
    localStorage.clear();
  };

  const handleLogoutCancel = () => {
    setIsLogoutDialogOpen(false);
  };

  const handleProfileClick = () => {
    handleClose();
    setIsProfileDialogOpen(true);
  };

  const handleProfileUpdate = () => {
    // Implement profile update logic here
    setIsProfileDialogOpen(false);
  };

  // const handleDashboardClick = () => {
  //   handleClose();
  //   setIsDashboardDialogOpen(true);
  // };

  const handleDashboardClick = () => {
    navigate("/dashboard"); // Navigate to the new dashboard page
  };
  
  return (
    <div>
      <IconButton
        size="large"
        aria-label="account of current user"
        aria-controls="menu-appbar"
        aria-haspopup="true"
        onClick={handleMenu}
        color="inherit"
        >
        {userProfileImage ? (
          <div
            style={{
              width: 40,
              height: 40,
              borderRadius: "50%", // Mimic Avatar's rounded style
              backgroundColor: "#ccc",
              display: "flex",
              alignItems: "center",
            }}
          >
            <div
              display="flex"
              alignItems="center"
              justifyContent="center"
              style={{ width: "100%", height: "100%" }}
            >
              <span
                style={{
                  color: "#080209",
                  fontSize: "2rem",
                  fontWeight: "bold",
                }}
              >
                {userProfileImage} {/* Display the letter */}
              </span>
            </div>
          </div>
        ) : (
          <div
            style={{
              width: 40,
              height: 40,
              borderRadius: "50%", // Mimic Avatar's rounded style
              backgroundColor: "#ccc",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              color: "#fff",
              fontSize: "1rem",
              fontWeight: "bold",
            }}
          >
            {userProfileImage} {/* Display letter or fallback */}
          </div>
        )}
      </IconButton>

      <Menu
        id="menu-appbar"
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        keepMounted
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        open={Boolean(anchorEl)}
        onClose={handleClose}
      >
        <MenuItem onClick={handleProfileClick}>Profile</MenuItem>
        <MenuItem onClick={handleAdmin}>Write a Post</MenuItem>
        <MenuItem onClick={handleDashboardClick}>Dashboard</MenuItem>
        {/* <MenuItem onClick={handleEarningsClick}>Earnings</MenuItem> */}
        <MenuItem onClick={handleLogoutClick}>Logout</MenuItem>
      </Menu>

      {/* Logout Dialog */}
      <Dialog
        open={isLogoutDialogOpen}
        onClose={handleLogoutCancel}
        aria-labelledby="logout-dialog-title"
      >
        <DialogTitle id="logout-dialog-title">{"Confirm Logout"}</DialogTitle>
        <DialogContent>
          Are you sure you want to exit your account?
        </DialogContent>
        <DialogActions>
          <Button onClick={handleLogoutCancel}>No</Button>
          <Button onClick={handleLogoutConfirm} autoFocus>
            Yes
          </Button>
        </DialogActions>
      </Dialog>

      {/* Profile Dialog */}
      <Dialog
        open={isProfileDialogOpen}
        onClose={() => setIsProfileDialogOpen(false)}
        aria-labelledby="profile-dialog-title"
      >
        <DialogTitle id="profile-dialog-title">User Profile</DialogTitle>
        <DialogContent>
          <TextField
            autoFocus
            margin="dense"
            id="username"
            label="Username"
            type="text"
            fullWidth
            variant="outlined"
            value={username}
            disabled
          />
          <TextField
            margin="dense"
            id="email"
            label="Email Address"
            type="email"
            fullWidth
            variant="outlined"
            value={email}
            disabled
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setIsProfileDialogOpen(false)}>Cancel</Button>
          <Button onClick={handleProfileUpdate}>Update</Button>
        </DialogActions>
      </Dialog>
      {/* Dashboard Dialog
      <Dialog
        open={isDashboardDialogOpen}
        onClose={() => setIsDashboardDialogOpen(false)}
        aria-labelledby="dashboard-dialog-title"
      >
        <DialogTitle id="dashboard-dialog-title">Dashboard</DialogTitle>
        <div>
      <p>Your Blog Posts</p>
      <ul>
        {userPosts.length > 0 ? (
          userPosts.map((post) => (
            <li key={post.user_id}>
              <h3>{post.user_id}</h3>
              <h3>{post.title}</h3>
              <h3>Total blogs:{totalPosts}</h3>
            </li>
          ))
        ) : (
          <p>No posts found for this user.</p>
        )}
      </ul>
    </div>
        <DialogContent>
          <Typography variant="h6">Blog Statistics</Typography>
          <Grid container spacing={2}>
            <Grid item xs={6}>
              <Typography>Total Posts: 25</Typography>
            </Grid>
            <Grid item xs={6}>
              <Typography>Posts This Month: 5</Typography>
            </Grid>
            <Grid item xs={6}>
              <Typography>Posts Today: 1</Typography>
            </Grid>
            <Grid item xs={6}>
              <Typography>Most Popular Topic: React</Typography>
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setIsDashboardDialogOpen(false)}>Close</Button>
        </DialogActions>
      </Dialog> */}
    </div>
  );
}

export default UserProfileMenu;
